import React, { useEffect, useState } from "react";
import { Tab, Nav } from 'react-bootstrap';
import secureStorage from '../../../config/encrypt';
import { useSearchParams,Link } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux'
import { toast } from "react-toastify";
import FullPageLoader from '@src/common/FullPageLoader';
import InsuranceListTable from '@src/pages/insurance/list/InsuranceListTable';
import InsuranceListTopFilter from '@src/pages/insurance/list/InsuranceListTopFilter';
import {getInsuranceList, leadListFilters,raisedSoa,downloadAllPolicies} from '@src/store/slices/insurance';
import {STATUS_TYPE,LEAD_LIST_FILTER, STATUS_CODES} from '@src/config/constant';
import * as HELPER from "@src/config/helper";
import RaisedSoaConfirmPopup from './RaisedSoaConfirmPopup';


function InsuranceList() {
    // const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const insuranceState = useSelector((state: any) => state.insurance);
    // const commonState = useSelector((state: any) => state.common);
    const [loading, setLoading] = useState<boolean>(false);
    const [insuranceList, setInsuranceList] = useState<any>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const [selectedFilters, setSelectedFilters] = useState<any>({ page_number: 1,apptype:4,lead_type:6, status_type:"submitted",datetype:"mtd"});
    const [activeTab, setActiveTab] = useState<any>('');
    const [showPendingAmountDiv, setShowPendingAmountDiv] = useState(false);
    const [isCreateAccess , setIsCreateAccess] = useState(false);
    const [showRaisedSoaConfirmPopup, setShowRaisedSoaConfirmPopup] = useState(false);
    const [insuranceListCount , setInsuranceListCount] = useState(0);
    const [downloadingProcess, setDownloadingProcess] = useState(false);
   

    let searchKey: any = searchParams.get('searchKey');
    let status_type: any = searchParams.get('status_type');
    let datetype: any = searchParams.get('datetype');
    let from_date: any = searchParams.get('from_date');
    let to_date: any = searchParams.get('to_date');
    let soa_raised: any = searchParams.get('raised_soa');


    useEffect(() => {
        let updatedSelctedFilters: any = {...selectedFilters};
        if (searchKey) {
            updatedSelctedFilters['searchKey'] = searchKey;
        }
        if(soa_raised){
            updatedSelctedFilters['raised_soa'] = +soa_raised;
        }
        if (status_type) {
            updatedSelctedFilters['status_type'] = status_type;
            setActiveTab(status_type);
        }
        if (datetype) {
            if(datetype!=="cdr"){
                let {from_date,to_date}:any= HELPER.dateReturn(datetype);
                if(from_date){
                    updatedSelctedFilters['from_date'] = from_date;
                }
                if(to_date){
                    updatedSelctedFilters['to_date'] = to_date;
                }
            }
            updatedSelctedFilters['datetype'] = datetype;
            if (from_date) {
                updatedSelctedFilters['from_date'] = from_date;
            }
            if (to_date) {
                updatedSelctedFilters['to_date'] = to_date;
            }

        }
       

        if (!searchKey && !datetype && !status_type) {

            let date_type:any = LEAD_LIST_FILTER?.taskSummaryFilters[1].value;
            updatedSelctedFilters['datetype']=date_type;
            let {from_date,to_date}:any= HELPER.dateReturn(date_type);
            if(from_date){
                updatedSelctedFilters['from_date'] = from_date;
            }
            if(to_date){
                updatedSelctedFilters['to_date'] = to_date;
            }
            if(!updatedSelctedFilters?.['status_type']){
                updatedSelctedFilters['status_type'] = STATUS_TYPE[0].value;
            }
        
        } else {
            if(!updatedSelctedFilters?.['status_type']){
                updatedSelctedFilters['status_type'] = STATUS_TYPE[0].value;
            }
            setSelectedFilters((prev: any) => { return { ...prev, ...updatedSelctedFilters }; });
        }
        
        setActiveTab(updatedSelctedFilters['status_type']);
        //setShowPendingAmountDiv(pendingAmountDiv);
        getInsuranceListing(updatedSelctedFilters);
        // eslint-disable-next-line
    }, [searchKey,datetype,status_type])

    useEffect(() => {
        if (Object.keys(insuranceState.insuranceListFilters).length) {
            setSelectedFilters({ ...insuranceState.insuranceListFilters });
        }
    }, [insuranceState]);

    //GET INSURANCE LIST API
    const getInsuranceListing = (params: any) => {
        setPaginationData({}); 
        let filters:any = {...params} 
        if(insuranceState.insuranceListFilters.datetype){
            filters.datetype = insuranceState.insuranceListFilters.datetype 
        }
        if(filters.from_date ==="" && insuranceState.insuranceListFilters.from_date){
            filters.from_date = insuranceState.insuranceListFilters.from_date
        }else{

        }
        if(filters.to_date ==="" && insuranceState.insuranceListFilters.to_date){
            filters.to_date = insuranceState.insuranceListFilters.to_date
        } 
        dispatch(leadListFilters(filters));
        let modifiedFilters = { ...filters };
        if(!modifiedFilters?.searchKey) delete modifiedFilters["searchKey"];
        delete modifiedFilters["datetype"];
        
        setLoading(true);
        dispatch(getInsuranceList(modifiedFilters)).then((res: any) => {
            setLoading(false)
            if (res && res.status === STATUS_CODES['success']) {
                setPaginationData({ ...res.pagination})
                setInsuranceList([])
                setInsuranceListCount(res.data.length);
                if(modifiedFilters?.status_type && (res?.pagination?.[modifiedFilters?.status_type])){
                    setInsuranceList([...res.data])
                }
                if(modifiedFilters && modifiedFilters.status_type==="pending_payment"){
                    if(!modifiedFilters?.raised_soa){
                        setShowPendingAmountDiv(true);
                    }else if(modifiedFilters?.raised_soa && modifiedFilters?.raised_soa===0){
                        setShowPendingAmountDiv(true);
                    }else{
                        setShowPendingAmountDiv(false);
                    }
                }else{
                    setShowPendingAmountDiv(false);
                }
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const activeTabHandler = (tab: any) => {
        let filters = {...selectedFilters, page_number: 1,status_type:tab};
        let datetype:any= ``;
        if(tab==="pending_payment"){
            datetype=LEAD_LIST_FILTER?.pendingPaymentFilters[0].value;
        }else{
            datetype=LEAD_LIST_FILTER?.taskSummaryFilters[1].value;
        } 
        let {from_date,to_date}:any= HELPER.dateReturn(datetype);
        filters = {...filters, datetype:datetype,from_date,to_date}; 
        setActiveTab(tab);
        getInsuranceListing(filters);
    }

    const setSearchKeyword = (searchKey:any) => {
        let updatedSelctedFilters: any = {...selectedFilters};
        updatedSelctedFilters['searchKey'] = (searchKey)?searchKey:'';
        setSelectedFilters(updatedSelctedFilters);
    }

    const handleKeyDown = (event:any) => {
        if (event.key === "Enter") {
            getInsuranceListing(selectedFilters);
        }
    };

    const updateListFromChlid = (filterParams: any) => {
        getInsuranceListing(filterParams);
    }

    const updateUrl = (filterParams:any,filterKey: string) => {
        if(filterKey === 'resetAll'){
            if(searchParams.size){
                searchParams.delete('datetype');
                searchParams.delete('status_type');
                searchParams.delete('searchKey');
                searchParams.delete('from_date');
                searchParams.delete('to_date');
                searchParams.delete('raised_soa');
                delete selectedFilters['searchKey'];
                setSearchParams(searchParams);
            }else{
                getInsuranceListing(filterParams);
            }
            setSelectedFilters({...filterParams});
            
        }
    }

    useEffect(() => {
        const loggedInUser = secureStorage.getItem("authAgentUserInfo");
        if(loggedInUser.user_data.status === 1){
          setIsCreateAccess(true);
        }else{
          setIsCreateAccess(false);
        }
    }, []);

    // const addNewApp = () => {
    //     navigate('/create-insurance-policy?step=insurance_form');
    // }

    const is_raised_soa_confirm = () => {
        setShowRaisedSoaConfirmPopup(true);
    }

    const raised_soa = () => {
        setShowRaisedSoaConfirmPopup(false);
        let filters={...selectedFilters,raised_soa:0};
        delete filters["datetype"];
        delete filters["page_number"];

        setLoading(true);
        raisedSoa(filters).then((res: any) => {
            setLoading(false)
            if (res && res.status === STATUS_CODES['success']) {
                getInsuranceListing(selectedFilters);
               toast.success(res.message || res?.data?.message);
               getInsuranceListing(selectedFilters);
            }else{
                toast.error(res.message || res?.data?.message);
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const downloadAllPolicyZip = async (docParams: any) => {
        setDownloadingProcess(true);
        try {
            setDownloadingProcess(true);
            const response:any = await downloadAllPolicies(docParams);
            if (response?.data?.doc_arr?.length > 0) {
                await HELPER.downloadPolicy(response.data.doc_arr,'all_policies.zip','multiple');
            } else {
                toast.error("No File Found");
            }
        } catch (error) {
            toast.error("Failed to download policies.");
        }finally{
            setDownloadingProcess(false);
        }
    };
   
    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <RaisedSoaConfirmPopup show={showRaisedSoaConfirmPopup} handleClose={() => {
                setShowRaisedSoaConfirmPopup(false)
            }} confirmNo={() => setShowRaisedSoaConfirmPopup(false)} confirmYes={raised_soa}></RaisedSoaConfirmPopup>
            <div className="container-fluid wap-bg-white">
                <div className="top-heading financer-lead-heding insurance-top-filer-heading d-flex">
                    <h1>Insurance Application List</h1>
                    {
                        isCreateAccess && 
                        <Link to='/create-insurance-policy'>
                            
                            <button className="btn-primary btn-width-auto" >
                                <i className="ic-add"></i>Create Lead</button>
                            
                        </Link>
                    }
                </div>
                <div className="loan-filter-bg">
                    <div className="top-filter-bg insurance-filter-outer">
                        <InsuranceListTopFilter 
                            submitHandler={(filterParams: any) => { updateListFromChlid(filterParams); }}
                            updateUrl={(filterParams:any,filterKey:any)=>updateUrl(filterParams,filterKey)}
                            loader={(params: any) => setLoading(params)}
                            downloadPolicyZip={(docParams: any) => { downloadAllPolicyZip(docParams); }}
                            insuranceCount={insuranceListCount}
                            idDownloading = {downloadingProcess}
                        />
                    </div>
                    {
                        showPendingAmountDiv && 
                        <div className="top-filter-bg m-lg-t pending-amt-outer">
                            <div className="pending-amt-txt">
                                <div>
                                Pending Amount <span>{HELPER.addCurrencyFormatting(paginationData?.total_pending_amount) || 0}</span>
                                </div>

                                {
                                (paginationData && Object.keys(paginationData).length  && paginationData?.total_pending_amount>0) && <button className="btn-primary btn-width-auto m-lg-l" onClick={is_raised_soa_confirm}>Raised SOA</button>
                                
                                }
                            </div>
                            <div className="check-needs">
                                <i className="ic-info-icon1"></i>
                                Cheque needs to be paid - “OTO Insurance”
                            </div>
                        </div>
                    }
                    <div className=" insurnace-appliction-table-outer m-lg-t">
                    {
                        
                        activeTab && <Tab.Container id="left-tabs-example"  defaultActiveKey={activeTab}>
                            <Nav variant="pills" className="flex-column tab-line nav nav-pills" onSelect={(k) => activeTabHandler(k)}>
                                <div className="tab-list">
                                    {
                                        STATUS_TYPE.map((data: any, key: number) =>
                                        <Nav.Item key={data.value}>
                                        <Nav.Link eventKey={data.value} >
                                        {data.label} 
                                        <span className= "list-chips">
                                        {(paginationData && paginationData[data.value]) || 0}
                                        </span>
                                        </Nav.Link>
                                        </Nav.Item>
                                        )
                                    }
                                </div>
                                <fieldset className="search-bx">
                                    <div className="material" title='Search By Insurance ID, Customer Name, Plate Number'>
                                        <input id="" type="text" placeholder="Search By Insurance ID, Customer Name, Plate Number" name="RoleName" className="form-input lead_search_input" value={selectedFilters?.searchKey || ""} onChange={(e) => setSearchKeyword(e.target.value)} onKeyDown={handleKeyDown} />
                                        <i className="ic-search"></i>
                                    </div>
                                </fieldset>
                            </Nav>


                            <Tab.Content>
                                <Tab.Pane eventKey={activeTab}>
                                    <InsuranceListTable 
                                    insuranceList={insuranceList} 
                                    paginationData={paginationData} 
                                    getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} />
                                </Tab.Pane>
                                
                            </Tab.Content>
                        </Tab.Container>
                       
                    }
                     </div>
                </div>
            </div> 
        </React.Fragment>
    )
}

export default InsuranceList;